import { AccountCircle, Dashboard, Engineering, Groups, ManageAccounts, SupervisorAccount, Settings, History, PlaylistAddCheck, Layers, Speed } from '@material-ui/icons'
// routes
import { PATH_DASHBOARD, ROOTS_PCB } from '../../routes/paths'
// components
import SvgIconStyle from '../../components/SvgIconStyle'
import HawkOwlLogo from '../../components/HawkOwlLogo'

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: '100%', height: '100%' }}
  />
)

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  kanban: getIcon('ic_kanban'),
  tickets_icon: getIcon('ticket_icon'),
  project:getIcon('project-manager'),
  // tickets_icon: getIcon('ic_kanban'),
}

const sidebarConfig = [
  // // GENERAL
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'dashboard',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: <Dashboard />,
  //       // icon: ICONS.dashboard
  //     },
  //     // { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics }
  //   ]
  // },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      // MANAGEMENT : USER
      {
        title: 'dashboard',
        path: PATH_DASHBOARD.general.app,
        icon: <Dashboard />,
        // icon: ICONS.dashboard
      },
      {
        title: 'Performance',
        path: PATH_DASHBOARD.performance,
        icon: <Speed />,
      },

      {
        title: 'Tickets',
        path: PATH_DASHBOARD.tickets.root,
        // icon: <i className='ticketIcon' />
        icon: ICONS.tickets_icon,
        exact: true,
      },
      {
        title: 'Staff Management',
        path: PATH_DASHBOARD.user.root,
        icon: <Groups />,
        hideForRoles: [3],
        children: [
          { title: 'Staffs', path: PATH_DASHBOARD.user.cards },
          { title: 'Staff Roles', path: PATH_DASHBOARD.user.roles }
        ]
      },
      {
        title: 'Clients',
        path: PATH_DASHBOARD.client.cards,
        // icon: ICONS.user,
        icon: <AccountCircle />,
        hideForRoles: [3]
      },
      {
        title: 'Projects',
        path: PATH_DASHBOARD.projects.list,
        icon: <i className='projectsIcon' />
        // icon: ICONS.project
      },
      {
        title: 'Modules',
        path: PATH_DASHBOARD.projects.modules,
        icon: <Layers />
      },
      {
        title: 'Status Log',
        path: PATH_DASHBOARD.tickets.activitylog,
        icon: <History />
      },
      {
        title: 'Test Cases',
        path: PATH_DASHBOARD.testcases,
        icon: <Engineering />
      },
      {
        title: 'HawkOwl',
        path: PATH_DASHBOARD.hawkowl,
        icon: <HawkOwlLogo size={22} />,
        hideForRoles: [3]
      },
      // {
      //   title: 'Test Scenario',
      //   path: PATH_DASHBOARD.testscenarios,
      //   icon: <PlaylistAddCheck />
      // },
      {
        title: 'Settings',
        path: PATH_DASHBOARD.settings,
        icon: <Settings />,
        hideForRoles: [2, 3]
      },
      // // MANAGEMENT : E-COMMERCE
      // {
      //   title: 'e-commerce',
      //   path: PATH_DASHBOARD.projects.root,
      //   icon: ICONS.cart,
      //   children: [
      //     { title: 'shop', path: PATH_DASHBOARD.projects.shop },
      //     { title: 'product', path: PATH_DASHBOARD.projects.productById },
      //     { title: 'list', path: PATH_DASHBOARD.projects.list },
      //     { title: 'create', path: PATH_DASHBOARD.projects.newProduct },
      //     { title: 'edit', path: PATH_DASHBOARD.projects.editById },
      //     { title: 'checkout', path: PATH_DASHBOARD.projects.checkout },
      //     { title: 'invoice', path: PATH_DASHBOARD.projects.invoice }
      //   ]
      // },

      // // MANAGEMENT : BLOG
      // {
      //   title: 'blog',
      //   path: PATH_DASHBOARD.blog.root,
      //   icon: ICONS.blog,
      //   children: [
      //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
      //     { title: 'post', path: PATH_DASHBOARD.blog.postById },
      //     { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
      //   ]
      // }
    ]
  },

  // // APP
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     { title: 'mail', path: PATH_DASHBOARD.mail.root, icon: ICONS.mail },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban }
  //   ]
  // }
]

export default sidebarConfig
